export default __webpack_public_path__ + "static/media/facebook.1972fc10.svg";